import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import isPropValid from '@emotion/is-prop-valid';
import { Link } from '@infl-ts/ui-advocate-components';
import { Box, css, styled } from '@mui/material';
import NavLink from '../nav-link';
import { jsx as _jsx } from "react/jsx-runtime";
var SizedImage = styled('img', {
  shouldForwardProp: isPropValid
})(function (_ref) {
  var isDesktop = _ref.isDesktop;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    object-fit: contain;\n    min-width: ", ";\n    height: 40px;\n    margin: 0;\n    position: relative;\n  "])), isDesktop ? '100px' : '0');
});
var ImageWrapper = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  > span > span {\n    display: none !important;\n  }\n"])));

var HomeLink = function HomeLink(_ref2) {
  var homeLink = _ref2.homeLink,
      isDesktop = _ref2.isDesktop;
  return homeLink.typename === 'NavBlockLogoLink' ? /*#__PURE__*/_jsx(Link, {
    sx: {
      mr: {
        xs: 0,
        lg: 7
      },
      ml: 1,
      display: 'flex',
      flexGrow: function flexGrow(theme) {
        return theme.site.navbarAlignment === 'right' ? 1 : 'unset';
      },
      alignItems: 'center',
      textAlign: 'center',
      minWidth: {
        xs: 0,
        md: 'auto'
      },
      maxHeight: 40
    },
    href: homeLink.href,
    children: /*#__PURE__*/_jsx(ImageWrapper, {
      sx: {
        minWidth: {
          xs: 0,
          md: 'auto'
        }
      },
      children: /*#__PURE__*/_jsx(SizedImage, {
        src: homeLink.imgUrl,
        alt: homeLink.display,
        isDesktop: isDesktop
      })
    })
  }) : isDesktop ? /*#__PURE__*/_jsx(NavLink, {
    link: homeLink,
    sx: {
      px: 3,
      whiteSpace: 'nowrap'
    },
    isDesktop: isDesktop
  }) : null;
};

export default HomeLink;